<template>
  <div>
    <el-upload
      ref="upload"
      class="upload-demo"
      :action="actionUrl"
      name="files"
      :on-success="handleSuccess"
      :headers="inputHeaders"
      :on-exceed="handleOverNum"
      :on-progress="handleLoading"
      :on-error="handleError"
      :file-list="fileList"
      :show-file-list="false"
      :data="uploadObj"
      :disabled="detailFlagInfo"
      :limit="limit"
      :multiple="multiple"
      :style="{display: detailFlagInfo ? 'none' : 'block'}"
      clearFiles
      :before-upload="beforeUpload">
      <span class="font-bold" :class="{'required': required}" v-if="label">{{label}}</span>
      <el-tooltip placement="top" v-if="showTipContent" popper-class="red-popper" effect="light">
        <div slot="content" v-html="showTipContent"></div>
        <el-button class="upload-btn" size="small" type="primary">点击上传</el-button>
      </el-tooltip>
      <el-button class="upload-btn" size="small" type="primary" v-if="!showTipContent">点击上传</el-button>
    </el-upload>
    <component :is="hiddenInfo ? 'div' : 'el-tag'" v-for="(item,index) in fileList" :key="index"
            :style="{marginRight: '10px',marginBottom: hiddenInfo ? '0' : '10px',clear: 'both',display:isBlock ? 'block' : 'inline-block',}">
      <div class="file-wrap" v-if="!hiddenInfo">
        <el-tooltip class="item" effect="dark"
                    placement="top" >
          <div slot="content" style=" flex-wrap:wrap">文件名：{{item.fileName}}<br/><br/>上传时间：{{item.createTime}}</div>
          <span v-if="isBlock" style="white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">{{item.fileName}}</span>
          <!-- overflow: hidden;
            white-space: nowrap; -->


          <span v-if="!isBlock" :style="{width: innerWidth,'text-overflow': 'ellipsis','white-space': 'nowrap',overflow: 'hidden'}">
            {{item.fileName}}
          </span>
        </el-tooltip>
        <a style="cursor: pointer; margin-left: 20px" @click="handleDowLoad(item)"> 下载 </a>
        <a style="cursor: pointer"
           target="_blank" @click="previewUpload(item)">&nbsp| 预览 </a>
        <a v-if="!detailFlagInfo" style="cursor: pointer; color: red; text-decoration-line: none"
           @click="handleRemove(item)">&nbsp| 删除 </a>
      </div>
      <el-button
        v-if="hiddenInfo"
        style="padding: 7px 9px"
        type="primary"
        size="mini"
        @click="previewUpload(item)"
      >
        <i class="el-icon-view"></i>查看
      </el-button>
    </component>
    <!--<br>-->
    <el-tag v-if="loadingFlag" type="danger">
      <span>请耐心等待<i class="el-icon-loading"></i></span>
    </el-tag>
    <preview-img :imgSrc="imgSrc" :visible="showPreviewImg" :width="fileSuffix === 'pdf' ? '660px' : '500px'" :iframeHeight="'820px'" title="预览" :fileSuffix="fileSuffix" v-if="showPreviewImg" @close="closeDialog"></preview-img>
  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import ArrayUtil from '@/util/arr'
  import FileV2Api from "@/api/common/FileV2Api";
  import previewImg from './preview-img'

  export default {
    name: "file-upload-new",
    components: {previewImg},
    computed: {
      ...mapGetters(["token", "userInfo"]),
      inputHeaders: function () {
        return {"Authorization": this.token}
      },
      //监听是否存在文件id，以便判断是否需要回显附件
      packageId: function () {
        return this.uploadObj.packageId
      },
      pageId(){
        return this.uploadObj.pageId
      },
    },
    data() {
      return {
        imgSrc: '',
        showPreviewImg: false,//是否展示图片预览弹窗
        fileSuffix: '',//图片后缀名
        fileList: [],
        loadingFlag: false,
        actionUrl: '/aaas-file/file/uploadFileRedis',
        isUpload:false, //判断是否是自己手动上传
      }
    },
    props: {
      innerWidth: {
        type: String,
        default: "92px"
      },
      uploadObj: {
        type: Object,
        required: true
      },
      acceptArr: {
        type: Array,
        default: function () {
          return []
        }
        // acceptArr 数组，上传的文件格式,元素为文件后缀名, 要求小写['pdf','jpg']
      },
      detailFlagInfo: {
        type: Boolean
      }, //判断是否只展示附件
      // 是否多选
      multiple: {
        type: Boolean,
        default: false
      },
      // 每次最多上传文件个数
      limit: {
        type: Number
      },
      // 最大文件大小
      maxUploadSize: {
        type: Number
        // default: 1024 * 1024 * 2
        // 100 * 1024 * 1024 => 100M
      },
      isBlock: {
        type: Boolean,
        default: false
      },
      hiddenInfo: {//是否显示文件名称及高亮信息
        type: Boolean,
        default: false
      },
      dragFlag: {//预览是否为弹框展示且可拖拽
        type: Boolean,
        default: false
      },
      showTipContent: {
        type: String,
        default: '请您确认上传的附件符合相关保密要求，无任何泄密风险，如有疑问请线下沟通解决，谢谢支持与理解！'
      }, //给点击上传按钮的提示信息
      pageName:{//分辨使用该组件的页面
        type:String,
      },
      label: {//上传文件对应的label
        type:String,
        default: ''
      },
      required: {//文件是否必须上传
        type:Boolean,
        default: false
      },
    },
    watch: {
      packageId:{
        handler(val, oldVal){
          if(!this.isUpload && val && this.uploadObj.pageId){
            this.handelList()
          }else if(!val){
            this.fileList = []
          }
        },
        deep:true
      },
      pageId:{
        handler(val, oldVal){
          if(!this.isUpload && val && this.uploadObj.packageId){
            this.handelList()
          }else if(!val){
            this.fileList = []
          }
        },
        deep:true
      },
    },
    created() {
      if(this.uploadObj.pageId && this.uploadObj.packageId){
        this.handelList()
      }
    },
    methods: {
      //关闭预览弹窗
      closeDialog(){
        this.showPreviewImg = false
        this.fileSuffix = ''
        this.imgSrc = ''
      },
      //附件上传之前
      beforeUpload(file) {
        if (this.acceptArr.length) {
          let formatName = file.name.substring(file.name.lastIndexOf('.') + 1)
          //文件格式与期望的不匹配
          if (this.acceptArr.includes(formatName) == false) {
            this.$message({
              type: 'error',
              message: '文件格式错误，请上传正确格式！'
            })
            return false
          }
        }
        //限制大小
        if (this.maxUploadSize && this.maxUploadSize < (file.size / 1024 /1024)) {
          this.$message({
            type: 'error',
            message: `文件大小不能超过${this.maxUploadSize}M`
          })
          return false
        }
      },

      // 附件列表
      handelList() {
        let data = {
          pageId: this.uploadObj.pageId,
          packageId: this.uploadObj.packageId
        }
        let fileV2Api = new FileV2Api();
        fileV2Api.listFile(data).then(res => {
          res.data.forEach(item => {
            item.name = item.fileName
          })
          this.fileList = res.data
          this.loadingFlag = false
          //若附件列表为空，则将packageId制空
          if(this.fileList.length == 0){
            this.isUpload = true //防止监听到packageId变化在调用一次附件列表
            this.uploadObj.packageId = ''
          }
        })
      },

      //上传过程中
      handleLoading(file, fileList) {
        this.loadingFlag = true
      },

      //上传失败
      handleError(file, fileList) {
        this.loadingFlag = false
      },

      //附件上传成功
      handleSuccess(res, file) {

        if (res.code == 1) {
          this.isUpload = true  //防止监听到packageId变化在调用一次附件列表
          this.uploadObj.packageId = res.data.packageId
          if(this.pageName === 'invitation_add'){
            this.$emit('clearManFile')
          }
          this.handelList()
        } else {
          this.loadingFlag = false
          if (this.uploadObj.packageId == '') {
            this.$refs.upload.clearFiles();
          } else {
            this.handelList()
          }
          this.$message.error('上传失败，请重新上传');
        }
      },

      //附件删除
      handleRemove(item) {
        if (!item.fileId) {
          return
        }
        let fileV2Api = new FileV2Api();
        let data = {
          pageId: this.uploadObj.pageId,
          fileId: item.fileId,
          packageId: item.packageId
        }
        fileV2Api.deleteFileRedis(data).then(res => {
          if (res.code == 1) {
            this.handelList()
            this.$message.success('附件删除成功')
          }
        })
      },

      //附件下载
      handleDowLoad(item) {
        window.location.href = '/aaas-file/file/downloadFile?' + 'fileId=' + item.fileId + '&token=' + this.token
        // window.location.href = '/share-file-system/file/download?' + 'fileId=' + item.fileId + '&token=' + this.token
      },

      //预览
      previewUpload(item) {
        if(this.dragFlag) {
          this.showPreviewImg = true
          this.fileSuffix = item.fileSuffix
          this.imgSrc = `/aaas-aspose/aspose/fileTransPdf?fileId=${item.fileId}&token=${this.token}&packageId=${this.uploadObj.packageId}&fileIndex=`
        } else {
          window.open('/aaas-aspose/aspose/fileTransPdf?' +
            'fileId=' + item.fileId +
            '&token=' + this.token +
            '&packageId=' + this.uploadObj.packageId +
            '&fileIndex=')
        }
      },

      //文件超出个数限制
      handleOverNum(files, localFileList) {
        if (this.multiple == false) {
          this.$message({
            type: 'error',
            message: '文件最多只能上传' + this.limit + '个'
          })
          return false
        } else {
          return true;
        }
      },
    }
  }
</script>

<style scoped lang="scss">
.upload-demo {
  margin-bottom: 10px;
  .font-bold {
    font-weight: 700;
    font-family: '微软雅黑';
    font-size: 16px;
    margin-right: 16px;
  }
  .required {
    &::before {
      content: '*';
      color: #F56C6C;
      position: absolute;
      left: -12px;
      top: 2px;
      font-weight: 400;
    }
  }
  .upload-btn {
    font-size: 14px;
  }
}
.file-wrap {
  display: flex;
  a {
    font-size: 14px;
  }
}
</style>
